import PropTypes from 'prop-types';

import { generateQeId, Tag } from '@ctct/ui-react';

const propTypes = {
  'data-qe-id': PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  large: PropTypes.bool,
};

const defaultProps = {
  large: false,
};

const CurrentPlanBadge = (props) => {
  const { 'data-qe-id': qeId, large, t } = props;

  return (
    <span className="current-plan">
      <Tag
        kind="info"
        size={large ? 'large' : 'default'}
        text={t('comparison-table.current-plan')}
        data-qe-id={generateQeId(qeId, 'current-plan-badge')}
      />
    </span>
  );
};

CurrentPlanBadge.propTypes = propTypes;
CurrentPlanBadge.defaultProps = defaultProps;
export default CurrentPlanBadge;
